import { h, render } from 'preact';
import SimilarProducts from './similar-products';

export default (element, data) => {
  const init = () => {
    render(
      <SimilarProducts handle={data.handle} title={data.title} />,
      element,
    );
  };

  init();
};
